const SESSION_EXPIRED_ERROR_CODE = "session_expired";
export {
  SESSION_EXPIRED_ERROR_CODE
};
//# sourceMappingURL=user.js.map
